import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import InactiveUser from '@/helpers/InactiveUser'
// @ts-expect-error JS module, no types provided
import Customers from '@/features/Customers'
// @ts-expect-error JS module, no types provided
import Profile from '@/features/Profile'
// @ts-expect-error JS module, no types provided
import ReleaseNotes from '@/features/ReleaseNotes'
// @ts-expect-error JS module, no types provided
import Account from '@/features/Account'
// @ts-expect-error JS module, no types provided
import SalesReport from '@/features/SalesReport/SalesReport'
// @ts-expect-error JS module, no types provided
import Reports from '@/features/Reports'
import ReportsPage from '@/features/Reports/ReportsPage'
// @ts-expect-error JS module, no types provided
import { ROUTES } from '@/routes.constants'
// @ts-expect-error JS module, no types provided
import { AuthenticationGuard } from '@/authentication-guard'
import { AccountDetailsPage } from '@/features/accounts/pages'
// @ts-expect-error JS module, no types provided
import { Auth0ProviderWithNavigate } from '@/auth0-provider-with-navigate'
import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
// @ts-expect-error JS module, no types provided
import NavBar from '@/widgets/NavBar'
import '@/app.css'
// @ts-expect-error JS module, no types provided
import NotificationPopup from '@/infrastructure/notificationPopup'
import { useDispatch, useSelector } from 'react-redux'
// @ts-expect-error JS module, no types provided
import Footer from '@/widgets/Footer'
// @ts-expect-error JS module, no types provided
import { selectUser } from '@/features/Profile/profile.selectors.js'
// @ts-expect-error JS module, no types provided
import { getJwtToken, selectUser as selectAuthUser } from '@/features/userContext/userContext.selectors'
import { useAuth0 } from '@auth0/auth0-react'
// @ts-ignore JS module, no types provided
import { isEmpty } from 'lodash'
// @ts-expect-error JS module, no types provided
import { fetchUser } from '@/features/Profile/profile.asyncActions'
// @ts-expect-error JS module, no types provided
import { setJwtToken, setUser as setAuthUser } from '@/features/userContext'
// @ts-expect-error JS module, no types provided
import { saveAccountUser } from '@/features/Account'
// @ts-expect-error JS module, no types provided
import { STATUS_ENUMS } from '@/features/Account/account.constants'
import * as Sentry from '@sentry/react'
import '@/app.css'
import '@/index.css'

import { api } from '@/lib/api-client'
import PlansRoute from './routes/plans/plans'
import NewPlanPage from './routes/plans/new'
import SubscriptionsRoute from '@/app/routes/subscriptions/subscriptions'
import NewSubscriptionPage from './routes/plans/new-subscription'
import PlanDetailsRoute from './routes/plans/subscription-details'
import EditPlanRoute from './routes/plans/edit-plan'
import UsersPage from '@/features/users/pages/UsersPage'
import SubscriptionDetailsPage from '@/features/subscriptions/pages/SubscriptionDetailsPage'
import FastboundFilesPage from '@/features/subscriptions/pages/FastboundFilesPage'

function AppLayout() {
	const { isAuthenticated, user, getAccessTokenSilently } = useAuth0()
	const jwtToken = useSelector(getJwtToken)
	const localAuthUser = useSelector(selectAuthUser)
	const cloudUser = useSelector(selectUser) as any
	const dispatch = useDispatch()

	useEffect(() => {
		const HandleAppDependencies = async () => {
			if (isAuthenticated) {
				Sentry.setUser({ email: user?.email, id: user?.sub })
				if (isEmpty(localAuthUser)) dispatch(setAuthUser(user))
				if (isEmpty(jwtToken)) {
					console.log('[AppLayout] Fetching JWT token...')
					dispatch(setJwtToken(await getAccessTokenSilently()))
				}

				if (jwtToken) {
					api.interceptors.request.use((config) => {
						config.headers.Authorization = `Bearer ${jwtToken}`
						return config
					})
				}
			}
		}
		HandleAppDependencies()
	}, [
		dispatch,
		getAccessTokenSilently,
		isAuthenticated,
		cloudUser,
		jwtToken,
		localAuthUser,
		user,
	])

	useEffect(() => {
		console.log('[AppLayout] cloudUser effect:', {
			cloudUserEmpty: isEmpty(cloudUser),
			jwtTokenEmpty: isEmpty(jwtToken),
			userEmpty: isEmpty(user),
			isAuthenticated,
		})
		if (
			isEmpty(cloudUser) &&
			!isEmpty(jwtToken) &&
			!isEmpty(user) &&
			isAuthenticated
		) {
			dispatch(fetchUser({ id: user?.sub, showNoError: true })).then(
				({ payload }: { payload: any }) => {
					if (payload)
						dispatch(saveAccountUser(user)).then(
							({ payload }: { payload: any }) => {
								console.log('[AppLayout] saveAccountUser result:', payload)
								payload &&
								dispatch(fetchUser({ id: payload.id, useCaching: false }))
							}
						)
				}
			)
		}
	}, [cloudUser, isAuthenticated, dispatch, user, jwtToken])

	return (
		<>
			{isAuthenticated && !isEmpty(cloudUser) && (
				<>
					{cloudUser.status === STATUS_ENUMS.ACTIVE && !cloudUser.isDeleted ? (
						<div className='min-h-screen flex flex-col'>
							<NavBar />
							<NotificationPopup />
							<main className='flex-1'>
								<Outlet />
							</main>
							<Footer />
						</div>
					) : (
						<InactiveUser />
					)}
				</>
			)}
		</>
	)
}

export const createAppRouter = () => {
	const {
		INACTIVE_USER,
		CUSTOMERS,
		USERS,
		PROFILE,
		RELEASE_NOTES,
		ACCOUNT,
		SALES_REPORT,
		ACCOUNT_DETAILS,
		BILLING,
		SUBSCRIPTIONS,
	} = ROUTES

	return createBrowserRouter([
		{
			path: '/*',
			element: (
				<Auth0ProviderWithNavigate>
					<AuthenticationGuard component={AppLayout} />
				</Auth0ProviderWithNavigate>
			),
			children: [
				{
					path: CUSTOMERS,
					element: <AuthenticationGuard component={Customers} />,
				},
				{
					path: PROFILE,
					element: <AuthenticationGuard component={Profile} />,
				},
				{
					path: USERS,
					element: <AuthenticationGuard component={UsersPage} />,
				},
				{
					path: RELEASE_NOTES,
					element: <AuthenticationGuard component={ReleaseNotes} />,
				},
				{
					path: ACCOUNT,
					element: <AuthenticationGuard component={Account} />,
				},
				{
					path: ACCOUNT_DETAILS,
					element: <AuthenticationGuard component={AccountDetailsPage} />,
				},
				{
					path: SALES_REPORT,
					element: <AuthenticationGuard component={SalesReport} />,
				},
				{
					path: '',
					element: <AuthenticationGuard component={Reports} />,
				},
				{
					path: INACTIVE_USER,
					element: <InactiveUser />,
				},
				{
					path: `plans`,
					element: <AuthenticationGuard component={PlansRoute} />,
				},
				{
					path: `plans/:id`,
					element: <AuthenticationGuard component={PlanDetailsRoute} />,
				},
				{
					path: `plans/new`,
					element: <AuthenticationGuard component={NewPlanPage} />,
				},
				{
					path: `plans/edit/:id`,
					element: <AuthenticationGuard component={EditPlanRoute} />,
				},
				{
					path: 'reports',
					element: <AuthenticationGuard component={ReportsPage} />,
				},
				{
					path: 'reports/:reportType',
					element: <AuthenticationGuard component={ReportsPage} />,
				},
				{
					path: 'subscriptions',
					element: <AuthenticationGuard component={SubscriptionsRoute} />,
				},
				{
					path: 'subscriptions/fastbound-files',
					element: <AuthenticationGuard component={FastboundFilesPage} />,
				},
				{
					path: 'subscriptions/fastbound',
					element: <AuthenticationGuard component={FastboundFilesPage} />,
				},
				{
					path: 'subscriptions/:id',
					element: <AuthenticationGuard component={SubscriptionDetailsPage} />,
				},
				{
					path: 'subscriptions/new',
					element: <AuthenticationGuard component={NewSubscriptionPage} />,
				}
			],
		},
	])
}

export default function AppRouter() {
	const {
		INACTIVE_USER,
		CUSTOMERS,
		PROFILE,
		RELEASE_NOTES,
		ACCOUNT,
		SALES_REPORT,
		ACCOUNT_DETAILS,
	} = ROUTES
	const router = createAppRouter()
	return <RouterProvider router={router} />
}
